import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from "axios";
import summeryerrors from '../../../../assets/images/summeryerrors.svg'

const SummaryofErrors = ({ currentIterationUUID }) => {
    const params = useParams();
    const moduleUUID = params?.uuid;
    const userData = useSelector(state => state.userSlice);
    const configData = useSelector((state) => state.configSlice);
    const [errorSummaryList, setErrorSummaryList] = useState([]);

    useEffect(() => {
        if (currentIterationUUID?.value?.length > 0) {
            getIterationErrorOfSummary(currentIterationUUID?.value);
        }
    }, [currentIterationUUID]);

    const getIterationErrorOfSummary = async (iterationId) => {
        const errorSummaryData = await axios.get(`${configData.config.API_URL}/api/analytics/session/error-summary/${moduleUUID}/${iterationId}`, {
            headers: {
                Authorization: `Bearer ${userData.token}`,
            }
        });
        setErrorSummaryList([...errorSummaryData.data.data]);
    }

    return (
        <>
            <div className="card h-100">
                <div className="card-body">
                    <div className='d-flex justify-content-between'>
                        <h5>Summary Of Errors</h5>
                        {/* <Select options={options} value={defaultValue} onChange={handleChange} placeholder="Select Scenario" /> */}
                    </div>
                    <div className='table-responsive mt-3' style={{ maxHeight: '350px', overflowY: 'auto' }}>

                        {errorSummaryList?.length > 0 ?
                            <table className="table table-hover  mb-0">
                                <thead>
                                    <tr>
                                        <th>
                                            S.N
                                        </th>
                                        <th>
                                            Step
                                        </th>
                                        <th>
                                            Description
                                        </th>
                                        <th>
                                            Status{" "}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {errorSummaryList.map((e, i) => {
                                        return (
                                            <tr key={i+1} >
                                                <td> {i + 1} </td>
                                                <td> {e.title} </td>
                                                <td> {e.taskDesc} </td>
                                                <td className='text-danger'> {e.statusText} </td>
                                            </tr>
                                        )
                                    })
                                    }


                                </tbody>
                            </table>
                            :
                            <div className='nodatafound'>
                                <img src={summeryerrors} alt="" />
                                <p className='text-danger'>No Errors found</p>
                            </div>
                        }

                    </div>
                </div>
            </div >
        </>
    )
}

export default SummaryofErrors
